import { Card } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import PageLayout from "../PageLayout/PageLayout";
import AgencyAreaCodes from "../Pages/AgencyPages/AgencyAreaCodes/AgencyAreaCodes";
import AgencyProduct from "../Pages/AgencyPages/AgencyProduct/AgencyProduct";
import AgencyUserPage from "../Pages/AgencyPages/AgencyUserPage/AgencyUserPage";
import AllocationPage from "../Pages/AllocationPage/AllocationPage";
import AnalysisPage from "../Pages/AnalysisPage/AnalysisPage";
import BankDashboardPage from "../Pages/BankDashboardPage/BankDashboardPage";
import CollecteazeAI from "../Pages/CollecteazeAI/CollecteazeAI";
import CoveragePage from "../Pages/CoveragePage/Coverage";
import DashboardPage from "../Pages/DashboardPage/DashboardPage";
import NewPerformancePage from "../Pages/NewPerformancePage/NewPerformancePage";
import AgencyPermissionPage from "../Pages/AgencyPages/AgencyPermissionPage/AgencyPermissionPage";
import RulesPage from "../Pages/RulesPage/RulesPage";
import PortfolioPage from "../Pages/PortfolioPage/PortfolioPage";
import ProductivityPage from "../Pages/ProductivityPage/ProductivityPage";
import ProfilePage from "../Pages/ProfilePage/ProfilePage";
import SignInPage from "../Pages/SignInPage/SignInPage";
import UploadPage from "../Pages/UploadPage/UploadPage";
import ScrollToTop from "../Reuseable/ScrollToTop/ScrollToTop";
import AllocationCaseDetailsPage from "../components/AllocationComp/AllocationCaseDetails/AllocationCaseDetails";
import BankDashboardComp from "../components/BankDashboardComp/BankDashboardComp";
import PortfolioEditMap from "../components/PortfolioComp/PortfolioEditMap/PortfolioEditMap";
import TraceabilityPage from "../Pages/TraceabilityPage/TraceabilityPage";
import AgentDetailsComp from "../components/TraceabilityComp/AgentDetailsComp/AgentDetailsComp";
import EmployeeDetail from "../components/AllocationComp/EmployeeDetail/EmployeeDetail";
import TargetAchivementsPage from "../Pages/TargetAchivementsPage/TargetAchivementsPage";
import ReportsPage from "../Pages/ReportsPage/ReportsPage";
import TargetAddNewTarget from "../components/TargetAchivements/TargetAddNewTarget/TargetAddNewTarget";
import FieldAgentAllocation from "../Pages/FieldAgentAllocation/FieldAgentAllocation";
import ViewAgentDetails from "../Pages/FieldAgentAllocation/ViewAgentDetails";
import CasesFeedback from "../components/AllocationComp/telecaller/CasesFeedback"
import TelecallerSummaryReport from "../Pages/SummaryReport/SummaryReportTelecaller";
import SMSPage from "../Pages/CommunicationPages/SMSPage";
import WhatsappPage from "../Pages/CommunicationPages/WhatsappPage";
import EmailPage from "../Pages/CommunicationPages/EmailPage";
import PTPListPage from "../components/PTPList/PTPListPage";
import CallBackList from "../components/CallbackList/CallbackList";
import AttendancePage from "../Pages/Attendance/AttendancePage";

const Routers = () => {
  const { token } = useSelector((state) => state?.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (token === null) {
      navigate("/sign-in");
    }
  }, []);

  return (
    <Card
      className="router_Main"
      variant="borderless"
      style={{ padding: "0px" }}
    >
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path="/"
          element={
            <PageLayout title="Dashboard">
              <DashboardPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/allocation/user-wise"
          element={
            <PageLayout title="allocation">
              <AllocationPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/allocation/user-wise/employee-details/:id"
          element={
            <PageLayout title="Employee Detail">
              <EmployeeDetail />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/allocation/cases"
          element={
            <PageLayout title="allocation">
              <AllocationPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/cases-feedback"
          element={
            <PageLayout title="Cases Feedback">
              <CasesFeedback />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/field-agent-allocation"
          element={
            <PageLayout title="Field Agent Allocations">
              <FieldAgentAllocation />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/telecaller-summary-report"
          element={
            <PageLayout title="Summary Report">
              <TelecallerSummaryReport />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/allocated-cases/:id"
          element={
            <PageLayout title="Allocated cases">
              <ViewAgentDetails />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/allocation/cases/customer-details/:allocationId"
          element={
            <PageLayout title="Customer Details">
              <AllocationCaseDetailsPage />
            </PageLayout>
          }
        />

        <Route
          exact
          path="/portfolio"
          element={
            <PageLayout title="Portfolio">
              <PortfolioPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/portfolio/:id"
          element={
            <PageLayout title="Portfolio Edit">
              <PortfolioEditMap />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/upload"
          element={
            <PageLayout title="Upload">
              <UploadPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/profile"
          element={
            <PageLayout title="Profile">
              <ProfilePage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/analysis/overview"
          element={
            <PageLayout title="Analysis">
              <AnalysisPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/analysis/coverage"
          element={
            <PageLayout title="Analysis">
              <CoveragePage />
            </PageLayout>
          }
        />

        {/* <Route
          exact
          path="/analysis/performance"
          element={
            <PageLayout title="Analysis">
              <PerformancePage />
            </PageLayout>
          }
        /> */}
        <Route
          exact
          path="/analysis/performance"
          element={
            <PageLayout title="Analysis">
              <NewPerformancePage />
            </PageLayout>
          }
        />

        <Route
          exact
          path="/agency/user"
          element={
            <PageLayout title="Agency">
              <AgencyUserPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/agency/product"
          element={
            <PageLayout title="Product">
              <AgencyProduct />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/agency/area-codes"
          element={
            <PageLayout title="AreaCodes">
              <AgencyAreaCodes />
            </PageLayout>
          }
        />

        <Route
          exact
          path="/dashboard"
          element={
            <PageLayout title="Dashboard">
              <DashboardPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/bank-dashboard/*"
          element={
            <PageLayout title="Dashboard">
              <BankDashboardPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/bank-dashboard/bank-details/:id"
          element={
            <PageLayout title="Bank">
              <BankDashboardComp />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/analysis/productivity"
          element={
            <PageLayout title="Analysis">
              <ProductivityPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/collecteaze-ai"
          element={
            <PageLayout title="Collecteaze AI">
              <CollecteazeAI />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/permission"
          element={
            <PageLayout title="Permissions">
              <AgencyPermissionPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/rules"
          element={
            <PageLayout title="Rules">
              <RulesPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/geo-tagging"
          element={
            <PageLayout title="GEO Tagging">
              <TraceabilityPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/geo-tagging/agent-details"
          element={
            <PageLayout title="GEO Tagging">
              <AgentDetailsComp />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/target-achievement/add-new-target"
          element={
            <PageLayout title="Target & Achievement">
              <TargetAddNewTarget />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/target-achievement"
          element={
            <PageLayout title="Target & Achievement">
              <TargetAchivementsPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/reports"
          element={
            <PageLayout title="Reports">
              <ReportsPage />
            </PageLayout>
          }
        />
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route
          exact
          path="/communication/sms"
          element={
            <PageLayout title="SMS">
              <SMSPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/communication/whatsapp"
          element={
            <PageLayout title="Whatsapp">
              <WhatsappPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/communication/email"
          element={
            <PageLayout title="Email">
              <EmailPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/telecaller/ptp-list"
          element={
            <PageLayout title="PTP List">
              <PTPListPage />
            </PageLayout>
          }
        />
        <Route
          exact
          path="telecaller/callback-list"
          element={
            <PageLayout title="Callback List">
              <CallBackList />
            </PageLayout>
          }
        />
        <Route
          exact
          path="/attendance"
          element={
            <PageLayout title="Attendance">
              <AttendancePage />
            </PageLayout>
          }
        />
      </Routes>
    </Card>
  );
};

export default Routers;
